import template from './payment_search.html';

class paymentSearchViewModel 
{
	constructor(page)
	{
		this.page = page;
		this.records = ko.observableArray();
		this.pending_payments = ko.observableArray();
		this.set_paid_payments = ko.observableArray();
		this.approval_person = ko.observable();
		
		let today = new Date();
		let firstDay = today.setDate(1);
		let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);

		this.date_start = ko.observable(new Date(firstDay).toJSON().slice(0,10));
		this.date_end = ko.observable(new Date(lastDay).toJSON().slice(0,10));

		this.payment_date_start = ko.observable(new Date(firstDay).toJSON().slice(0,10));
		this.payment_date_end = ko.observable(new Date(lastDay).toJSON().slice(0, 10));
		
		this.date_start.subscribe((value) => {
			this.page.updateData();
		});
		this.date_end.subscribe((value) => {
			this.page.updateData();
		});
		
		this.payment_date_start.subscribe((value) => {
			this.page.updateData();
		});
		
		this.payment_date_end.subscribe((value) => {
			this.page.updateData();
		});
	}

	async delete_payment(data)
	{
		let response = await Grape.alerts.confirm({type: 'danger', title: tr('Confirm'), message: tr('Are you sure you want to delete this payment?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/payment/delete', {'payment_id' : data.payment_id });

			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted'), title: tr('Success')});
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};
	
	async approve_payment(data)
	{
		let response = await Grape.alerts.confirm({type: 'info', title: tr('Confirm'), message: tr('Are you sure you want to approve this payment?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/payment/approve', {'payment_id' : data });

			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully approved payment'), title: tr('Success')});
				this.page.updateData();
			}
			else if (res.status == 'ERROR') 
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	async view_payment(row)
	{
		let data = ko.toJS(row);
		data.view = true;
		await Grape.dialog.open('GrapeAddPayment', { data: data });
		this.page.updateData();
	};

	
	async reject_payment(data)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Reject this payment?'), message: tr('Are you sure you want to reject this payment?')});
		if (response)
		{
			let reason = await Grape.alerts.prompt({type: 'warning', title: tr('Reason'), message: tr('Enter reason below')});
			if (reason)
			{
				let res = await Grape.fetches.postJSON('/payment/reject', {'payment_id' : data, 'reason': reason });
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: tr('Successfully rejected.'), title: tr('Success')});
					this.page.updateData();
				}
				else if (res.status == 'ERROR') 
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
			}
			else
				Grape.alerts.alert({type: 'danger', message: tr('No rejection reason provided'), title: tr('Invalid')});
		}
	};

	async edit_payment(row)
	{
		let data = ko.toJS(row);
		data.view = false;
		await Grape.dialog.open('GrapeAddPayment', { data: data });
		this.page.updateData();
	};

	download_requisition(res)
	{
		let payment_id = res;
		let url = '/download/payment/' + payment_id;
		window.open(url);
	};

	show_search_payment_help()
	{
		Grape.dialog.open('PaymentSearchHelp', {});
	}
};

class paymentSearchPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new paymentSearchViewModel(this);

		this.viewModel.reject_payment = this.viewModel.reject_payment.bind(this.viewModel);
		this.viewModel.view_payment = this.viewModel.view_payment.bind(this.viewModel);
		this.viewModel.edit_payment = this.viewModel.edit_payment.bind(this.viewModel);
		this.viewModel.delete_payment = this.viewModel.delete_payment.bind(this.viewModel);
		this.viewModel.download_requisition = this.viewModel.download_requisition.bind(this.viewModel);
	}

	async init()
	{
		document.title = tr('Payment Search');
		window.current_page_title(tr('Payment Search'));
		let buttonstring = [];
		let columns = [
			{field: 'payment_id', title: tr('ID'), sortable: true, align : 'left', width: '1%'},
			{field: 'requested_by', title: tr('Requested By'), sortable: true , align : 'left', width: '30%'},
			{field: 'payee', title: tr('Payee'), sortable: true , align : 'left', width: '30%'},
			{field: 'date_created', title: tr('Date Created'), sortable: true, align : 'left', width: '15%', searchable: false},
			{field: 'payment_date', title: tr('Payment Date'), sortable: true, align : 'left', width: '15%', searchable: false},
			{field: 'description', title: tr('Description'), sortable: true, align : 'left', width: '30%'},
			{field: 'total', title: tr('Total Amount'), width: '20%', sortable: true, align : 'left',
				formatter: function(value, row, index) {return 'R ' + row.total;}
			},
			{field: 'status', title: tr('Status'), sortable: true, align : 'left', width: '11%'},
			{field: 'Action',
				title: tr('Actions'),
				sortable: false,
				width: '300%',
				align : 'left',
				width: '1%',
				formatter: function(value, row, index) {
					let buttonstring = [];
					if (row.status == 'completed' || row.status == 'void' || row.status == 'rejected')
						buttonstring.push('<button class="ps-btn-primary ps-btn-sm edit_payment_button" disabled><span class="fa fa-pencil"></span></button>');
					else
						buttonstring.push('<button class="ps-btn-primary ps-btn-sm edit_payment_button"><span class="fa fa-pencil"></span></button>');

					buttonstring.push('<button class="ps-btn-default ps-btn-sm view_payment_button"><span class="fa fa-eye"></span></button>');
					buttonstring.push('<button class="ps-btn-danger ps-btn-sm delete_payment_button"><span class="fa fa-trash"></span></button>');
					if (row.status != 'rejected' && row.status != 'void')
						buttonstring.push('<button class="ps-btn-primary ps-btn-sm download_requisition_button" style="display: block; margin-top: 0.5em"><span class="fa-solid fa-download"></span>&nbsp;Download</button>');

					return `<div class="button-group">${buttonstring.join(' ')}</div>`;
				},
				events:{
					'click .reject_payment_button': (e, value, row, index) => {
						this.viewModel.reject_payment(row.payment_id);
					},
					'click .view_payment_button': (e, value, row, index) => {
						this.viewModel.view_payment(row);
					},
					'click .edit_payment_button': (e, value, row, index) => {
						this.viewModel.edit_payment(row);
					},
					'click .delete_payment_button': (e, value, row, index) => {
						this.viewModel.delete_payment(row);
					},
					'click .download_requisition_button': (e, value, row, index) => {
						this.viewModel.download_requisition(row.payment_id);
					}
				}
			}
		];

		this.tbl_employees = $('#tbl_payments').bootstrapTable({
			columns: columns,
			pagination: true,
			pageList: [10, 20, 50, 100],
			pageSize: 10,
			sidePagination: 'client',
			dataToolbar: '#toolbar',
			ordering: true,
			dataField: 'records',
			onPageChange: (number, size) => this.updateData(),
			onSort: (sortName, sortOrder) => this.updateData(),
			fixedColumns: true,
			fixedNumber: columns.length
		});
	};

	async updateData(filter = false)
	{
		let options = {
			table: 'v_subordinate_payments', 
			schema: 'grape_payment_approval',
			sortfield: 'payment_id',
			limit: 100000000,
			sortorder: 'DESC'
		};

		if (filter == true)
		{
			let filter_array = [];
			if (this.viewModel.date_start() && this.viewModel.date_end())
			{
				if (new Date(this.viewModel.date_end()) < new Date(this.viewModel.date_start()))
					Grape.alerts.alert({ type: 'warning', message: tr('End date cannot be before start date') });

				filter_array.push({ value: this.viewModel.date_end(), op: '<=', field: 'date_created' });
				filter_array.push({ value: this.viewModel.date_start(), op: '>=', field: 'date_created' });
			}

			if (this.viewModel.payment_date_start() && this.viewModel.payment_date_end())
			{
				if (new Date(this.viewModel.payment_date_end()) < new Date(this.viewModel.payment_date_start()))
					Grape.alerts.alert({ type: 'warning', message: tr('Payment end date cannot be before payment start date') });
				filter_array.push({ value: this.viewModel.payment_date_end(), operand: '<=', field: 'payment_date' });
				filter_array.push({ value: this.viewModel.payment_date_start(), operand: '>=', field: 'payment_date' });
			}

			options.filter = filter_array;
		}

		let table_options = $('#tbl_payments').bootstrapTable('getOptions');
		
		//LOGIC: Sort instantiate
		if (table_options.sortName && table_options.sortName != '')
		{
			options.sortfield = table_options.sortName;
			options.sortorder = table_options.sortOrder.toUpperCase();
		}

		if (this.viewModel.date_end() < this.viewModel.date_start())
			Grape.alerts.alert({ type: 'warning', message: tr('End date cannot be before start date') });
		
		if (this.viewModel.payment_date_end() < this.viewModel.payment_date_start())
			Grape.alerts.alert({ type: 'warning', message: tr('Payment end date cannot be before payment start date') });

		
		let res = await Grape.fetches.getJSON('/api/record', options);
		if (!res.records)
			res.records = [];

		$('#tbl_payments').bootstrapTable('load', res);
	};

	apply_filters()
	{
		let filter;
		this.updateData(filter = true);
	}
};

export default {
	route: '[/]payment_approval/payment_search',
	page_class: paymentSearchPage,
	template: template,
	template_filename: 'translation/payment_search' 
};
